import React from 'react';
import { Col, Divider, Row, Tooltip, Typography } from 'antd';
import { DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import AntCard from '../../../../components/AntCard/AntCard';
import AntRadio from '../../../../components/AntRadio/AntRadio';
import './SelectSingle.scss';
import AntButton from '../../../../components/AntButton/AntButton';
import AntInput from '../../../../components/AntInput/AntInput';
import AntInputNumber from '../../../../components/AntInputNumber/AntInputNumber';
import useSelectSingle from './useSelectSingle';


const SelectSingle = ({ deleteFn,questionNumber,getData,data,operation }) => {

  const {
    optionText,
    onChangeOptionText,
    score,
    question,
    onChangeQuestion,
    selectSOptions,
    addOption,
    deleteOption,
    description,
    onChangeDescription,
    onChangeOptionScore,
    resetFields,
    selectedOption,
    onChangeSelectedOption,
    resetDefaultFields
  } = useSelectSingle(questionNumber, getData,data,operation)
  return (
    <div style={{ paddingTop: '5%', overflow: 'hidden' }}>
      <AntCard title={
        <Row align="middle" gutter={16}>
          <Col><Typography>Question : {questionNumber + 1}</Typography></Col>
          <Col><Typography>type : Select Single</Typography></Col>
        </Row>
      }  style={{width:"100%"}}
        content={
          <Row justify="end" align="middle" gutter={[16, 16]}>
            <Col span={24}>
            {operation==="preview"? 
            <Typography><Typography.Text strong>{question}</Typography.Text></Typography>  
            :<AntInput placeholder={"Write Your Question"} label={"Question:"} value={question} onChange={onChangeQuestion} />} <Divider /></Col>
           {operation !=="preview"?
            <>
            <Col span={9}><AntInput placeholder={"Write Your Option Text"} label={"Option Text:"} value={optionText} onChange={onChangeOptionText} /></Col>
            <Col span={8}><AntInput placeholder={"Write  Option Description"} label={"Description:"} value={description} onChange={onChangeDescription} /></Col>
            <Col span={3}><AntInputNumber placeholder={"Score"} label={"Score:"} value={score} onChange={onChangeOptionScore} /></Col>
            <Col span={4}><AntButton text={"Add Option"} type={"primary"} color={"#b9bec3"} onClick={addOption} /></Col>
            </>:""}

            <Col span={24}> {operation !=="preview"?<Divider />:""}
              <div style={{ maxHeight: "210px", overflowX: 'hidden', overflowY: 'auto', padding: '5px', WebkitOverflowScrolling: 'touch' }}>
                <AntRadio options={selectSOptions} deleteFn={operation !=="preview"?deleteOption:undefined} isButton={true} value={selectedOption} onChange={onChangeSelectedOption} />
              </div>
            </Col>
          </Row>
        }
        actions={[
          <Row justify="end" align="middle" gutter={[16, 16]}>
            {operation==="create"?
            <Col span={2}>
              <Tooltip placement="bottom" title={"Reset"}>
                <ReloadOutlined key="reset" style={{ fontSize: '18px', color: "#2C2C2C" }} onClick={resetFields} />
              </Tooltip>
            </Col>:operation==="update"?             
            <Col span={2}>
              <Tooltip placement="bottom" title={"Reset Default"}>
                <ReloadOutlined key="reset" style={{ fontSize: '18px', color: "#2C2C2C" }} onClick={resetDefaultFields} />
              </Tooltip>
            </Col>:""}
            {deleteFn?
            <Col span={2}>
              <Tooltip placement="bottom" title={"Delete"}>
                <DeleteOutlined key="delete" style={{ fontSize: '18px', color: '#ff0000' }} onClick={() => { deleteFn(questionNumber) }} />
              </Tooltip>
            </Col>:""}
          </Row>
        ]} />
    </div>
  );
}

export default SelectSingle;
